function searchProductByTitle(glCardPricing, title) {
  return fetch(`/search/suggest.json?q=${title}&resources[type]=product`)
    .then(response => response.json())
    .then(data => {
      if (data?.resources?.results?.products?.length > 0) {
        const productId = data?.resources?.results?.products[0]?.id;
        glCardPricing.setAttribute("bss-b2b-product-id", productId);
        glCardPricing.setAttribute("bss-b2b-product-price", "");
      } else {
        console.log("No products");
      }
    })
    .catch(error => console.error("Error:", error));
}

setTimeout(() => {
  const targetNode = document.querySelector(".glFilter-search-popup ");
  const config = { attributes: true, childList: true, subtree: true };

  const debounceLog = debounce(() => {
    document.querySelector("#glFilter-search-popup, .glFilter-search-popup")?.classList.add("bss-b2b-search-bar");
    const glCards = document.querySelectorAll(".gl-card");
    if (glCards.length) {
      const promises = Array.from(glCards).map(glCard => {
        const productTitle = glCard.querySelector(".gl-card-title")?.getAttribute("title");
        const glCardPricing = glCard.querySelector(".gl-card-pricing");
        if (productTitle && glCardPricing) {
          return searchProductByTitle(glCardPricing, productTitle);
        }
        return Promise.resolve();
      });

      Promise.all(promises).then(async () => {
        const res = await BSS_B2B.storage.productStorage.load();
        if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
          document.dispatchEvent(
            new CustomEvent(`bss_b2b:SearchBarLoaded`, { bubbles: true, detail: res })
          );
        }
      });
    }
  }, 500);

  const callback = (mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        const newClass = mutation.target.className;
        if (newClass.includes("gflazyload")) {
          document.querySelector(".glFilter-search-popup, #glFilter-search-popup")?.classList.add("bss-b2b-search-bar");
          debounceLog();
        }
      }
    }
  };

  if (targetNode) {
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}, 2000);

(function updateRoorFooterLink() {
  const roorCollectionUrl = "/collections/roor-glass";

  function applyRoorFooterLink() {
    document.querySelectorAll(".brand-family-footer__link").forEach((link) => {
      if (link.textContent.trim().toLowerCase() === "shop all roor") {
        link.setAttribute("href", roorCollectionUrl);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyRoorFooterLink);
  } else {
    applyRoorFooterLink();
  }

  document.addEventListener("shopify:section:load", applyRoorFooterLink);
})();

(function ensureRoorFaqNavigation() {
  const faqUrl = "/pages/roor-faq";
  const faqTitle = "ROOR® FAQ";
  let updateQueued = false;

  function normalize(value) {
    return String(value || "").replace(/\s+/g, " ").trim().toUpperCase();
  }

  function directLinksForList(list) {
    const links = [];
    Array.from(list.children).forEach((child) => {
      if (!(child instanceof HTMLElement)) return;
      let link = null;
      if (child.matches("li")) {
        link = child.querySelector(":scope > a");
      } else if (child.matches("a")) {
        link = child;
      }
      if (link) links.push(link);
    });
    return links;
  }

  function addFaqToRoorLists() {
    document.querySelectorAll("ul, [role='list']").forEach((list) => {
      if (!(list instanceof HTMLElement)) return;
      const directLinks = directLinksForList(list);
      if (directLinks.length < 2) return;

      const labels = directLinks.map((link) => normalize(link.textContent));
      const hasRoorClassics = labels.some((label) => label === "CLASSICS" || label.includes("CLASSIC CUSTOM ROOR"));
      const hasRoorTech = labels.some((label) => label.includes("ROOR-TECH"));
      if (!hasRoorClassics || !hasRoorTech) return;

      const existingFaq = directLinks.find((link) => {
        const href = link.getAttribute("href") || "";
        return href.includes(faqUrl) || normalize(link.textContent) === normalize(faqTitle);
      });
      if (existingFaq) {
        existingFaq.setAttribute("href", faqUrl);
        return;
      }

      const sourceLink = directLinks.find((link) => normalize(link.textContent).includes("ROOR-TECH")) || directLinks[directLinks.length - 1];
      const sourceItem = sourceLink.closest("li");
      const item = sourceItem ? sourceItem.cloneNode(false) : document.createElement("li");
      const link = sourceLink.cloneNode(false);

      link.removeAttribute("id");
      link.removeAttribute("aria-current");
      link.setAttribute("href", faqUrl);
      link.setAttribute("data-roor-faq-nav", "true");
      link.textContent = faqTitle;
      item.appendChild(link);
      list.appendChild(item);
    });
  }

  function applyNavigation() {
    updateQueued = false;
    addFaqToRoorLists();
  }

  function queueNavigationUpdate() {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(applyNavigation);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", queueNavigationUpdate);
  } else {
    queueNavigationUpdate();
  }

  [250, 750, 1500, 3000, 5000].forEach((delay) => {
    window.setTimeout(queueNavigationUpdate, delay);
  });

  if (document.documentElement) {
    const menuObserver = new MutationObserver(queueNavigationUpdate);
    menuObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("shopify:section:load", queueNavigationUpdate);
})();

(function refreshKingKoneHomepageLogo() {
  const logoUrl = "https://cdn.shopify.com/s/files/1/0625/3438/5847/files/Untitled_-_July_28_2026_at_14.34.25-3_1_-squeezed.png?v=1785628232";

  function applyKingKoneLogo() {
    const wrapper = document.querySelector(".sream-about__brand--king-kone");
    const image = wrapper?.querySelector("img");
    if (!wrapper || !image) return;

    if (image.getAttribute("src") !== logoUrl) {
      image.setAttribute("src", logoUrl);
    }

    image.setAttribute("width", "500");
    image.setAttribute("height", "500");
    image.style.objectPosition = "center center";
    image.style.marginInline = "auto";
    image.style.background = "transparent";
    wrapper.style.justifyContent = "center";
    wrapper.style.alignItems = "center";
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyKingKoneLogo);
  } else {
    applyKingKoneLogo();
  }

  document.addEventListener("shopify:section:load", applyKingKoneLogo);
})();

(function removeHomepageBrandNumbers() {
  function removeNumbers() {
    document.querySelectorAll(".sream-about__grid > a > span").forEach((number) => {
      const label = number.textContent.trim();
      if (["01", "02", "03", "1", "2", "3"].includes(label)) {
        number.remove();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", removeNumbers);
  } else {
    removeNumbers();
  }

  document.addEventListener("shopify:section:load", removeNumbers);
})();
